import React, { useState } from 'react'
import Dialog from '@mui/material/Dialog'
import WelcomeMessage from '../3modules/Config/WelcomeMessage'

export default function Popup () {
  const welcomeMessage = localStorage.getItem('welcomeMessage')
    let customTitle = ''
    let customDescription = ''
    let customFooter = ''

    if(welcomeMessage){
        const {title, description, footer} = JSON.parse(welcomeMessage)
        customTitle = title
        customDescription = description
        customFooter = footer
    }

  const [open, setOpen] = useState(true)

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      maxWidth='xs'
      PaperProps={{
        style: { background: 'none' }
      }}
    >
        <WelcomeMessage title={customTitle} description={customDescription} footerDescription={customFooter} handleClose={handleClose} />
    </Dialog>
  )
}
